<script setup>
import { ref, onMounted, watch, getCurrentInstance, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useUserStore } from '../../../stores/user';
import { usePageLoadingStore } from '../../../../../stores/pageLoading';
import MyPageCorpJobFairCorpInfoView from './MyPageCorpJobFairCorpInfoView.vue';
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";

const props = defineProps({
  viewSource: {
    type: String,
    default: '',
  },
});

const { viewSource } = toRefs(props); // 기업정보 조회 api 분기 promotion (기업 홍보관)

const router = useRouter();
const loadingStore = usePageLoadingStore()

const userStore = useUserStore();
const { user, isAuthenticated } = storeToRefs(userStore);

const globals = getCurrentInstance().appContext.config.globalProperties;
const { alert } = globals;

const userCorpMasterYn = ref('N'); // 기업마스터유무
const userCorpId = ref(''); // 기업아이디

// 기업정보 관리 상세
const corpDetail = ref({});

// 조회
const retrieveList = () => {

  loadingStore.loading = true;
  if (viewSource.value === 'promotion') {
    mypageCorpInfoService.retrieveCorporation(userCorpId.value)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpDetail.value.setCorpInfo(result);
          }
        }).catch( (error) =>  {
      console.log(error);
      loadingStore.loading = false;
    });
  } else {
    jobFairCorpService.ojfCorporationDetail(userCorpId.value)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpDetail.value.setCorpInfo(result);
          }
        }).catch( (error) =>  {
      console.log(error);
      loadingStore.loading = false;
    });
  }
}

const onClickUpdate = () => {
  router.push({ name: 'MyPageCorpInfoUpdate', query: { corpId: userCorpId.value } });
}

onMounted(() => {
  retrieveList();
});

watch(user, (newUser) => {
  if (newUser) {
    userCorpId.value = newUser.userInfo?.corporation?.corpId || '';
    userCorpMasterYn.value = newUser.userInfo?.corpMasterYn || 'N';
  }
}, { immediate: true, deep: true });

</script>

<template>
  <div v-if="corpDetail !== 0">
    <MyPageCorpJobFairCorpInfoView ref="corpDetail" />
    <div class="btn-wrap text-right mb-xs">
      <KSASecondaryButton class="gray_button" v-if="user.userInfo.corpMasterYn === 'Y'" text="수정" @click="onClickUpdate" />
    </div>
  </div>
  <div v-else class="resume-wrap" style="display: flex; align-items: center; justify-content: center;">
    등록된 기업정보가 없습니다.
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

</style>
